import { type ButtonHTMLAttributes, forwardRef } from "react";

type Variant = "primary" | "secondary" | "ghost";
type Size = "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
}

const VARIANT_STYLES: Record<Variant, string> = {
  primary:
    "bg-sakura text-white border-b-4 border-sakura-edge hover:brightness-105 active:translate-y-1 active:border-b-0",
  secondary:
    "bg-bamboo text-white border-b-4 border-bamboo-edge hover:brightness-105 active:translate-y-1 active:border-b-0",
  ghost: "bg-transparent text-sumi border border-sumi-soft hover:bg-cream",
};

const SIZE_STYLES: Record<Size, string> = {
  md: "h-11 px-5 text-base rounded-button",
  lg: "h-14 px-6 text-lg rounded-button",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "primary", size = "md", fullWidth, className, children, disabled, ...rest },
  ref,
) {
  const cls = [
    "inline-flex items-center justify-center font-bold transition select-none",
    "disabled:opacity-50 disabled:cursor-not-allowed disabled:active:translate-y-0",
    VARIANT_STYLES[variant],
    SIZE_STYLES[size],
    fullWidth ? "w-full" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button ref={ref} className={cls} disabled={disabled} {...rest}>
      {children}
    </button>
  );
});
